import { render, staticRenderFns } from "./SetItem.vue?vue&type=template&id=cc0244ee"
import script from "./SetItem.vue?vue&type=script&lang=js"
export * from "./SetItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports